import moment from 'moment';
import ReactGA from 'react-ga4';

export const trackEnterEmailClickContinue = (availability: string) => {
  ReactGA.event({
    category: 'User',
    action: 'enter_email_click_continue',
    label: availability,
  });
};

export const trackSendVerificationEmailSuccess = () => {
  ReactGA.event({
    category: 'User',
    action: 'send_verification_email_success',
  });
};

export const trackSendVerificationEmailError = () => {
  ReactGA.event({
    category: 'User',
    action: 'send_verification_email_error',
  });
};

export const trackSendResetPwEmailSuccess = () => {
  ReactGA.event({
    category: 'User',
    action: 'send_reset_pw_email_success',
  });
};

export const trackSendResetPwEmailError = () => {
  ReactGA.event({
    category: 'User',
    action: 'send_reset_pw_email_error',
  });
};

export const trackEmailConfirmationClickResend = (label: string) => {
  ReactGA.event({
    category: 'User',
    action: 'email_confirmation_click_resend',
    label,
  });
};

export const trackEmailConfirmationClickGoBack = () => {
  ReactGA.event({
    category: 'User',
    action: 'email_confirmation_click_go_back',
  });
};

export const trackAccountCreateSuccess = () => {
  const timestampMills = moment(new Date()).valueOf();

  ReactGA.event({
    category: 'User',
    action: 'account_create_success',
    value: timestampMills,
  });
};

export const trackAccountCreateError = () => {
  ReactGA.event({
    category: 'User',
    action: 'account_create_error',
  });
};

export const trackLogInSuccess = (previousPage: string) => {
  const timestampMills = moment(new Date()).valueOf();

  ReactGA.event({
    category: 'User',
    action: 'log_in_success',
    label: previousPage,
    value: timestampMills,
  });
};

export const trackLogInError = (errMsg?: string) => {
  ReactGA.event({
    category: 'User',
    action: 'log_in_error',
    label: errMsg,
  });
};

export const trackLogOut = () => {
  ReactGA.event({
    category: 'User',
    action: 'log_out',
  });
};
